import { render, staticRenderFns } from "./NoticeEditTabInformation.vue?vue&type=template&id=3068bc81&scoped=true&"
import script from "./NoticeEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./NoticeEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./NoticeEditTabInformation.vue?vue&type=style&index=0&id=3068bc81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3068bc81",
  null
  
)

export default component.exports